enum SkipLinksTarget {
    MainNav = '#target-mainnav',
    Content = '#target-content',
};

const SkipLinks = {
    validTargets: [SkipLinksTarget.MainNav, SkipLinksTarget.Content],

    init: (element: HTMLElement) => {
        const links = element.querySelectorAll('.skip-links__link');
        links.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const target = link.getAttribute('href');
                if (SkipLinks.validTargets.includes(target as SkipLinksTarget)) {
                    if (target === SkipLinksTarget.MainNav) {
                        // Special case: if skip to main navigation, focus first focusable element (link) inside main navigation element:
                        const targetElement: HTMLElement = document.querySelector(target);
                        const focusables: NodeListOf<HTMLLinkElement> = targetElement?.querySelectorAll('[href], button, [tabindex]:not([tabindex="-1"])');
                        focusables[0]?.focus();

                    } else {
                        // Skip to content, just focus content wrapper element:
                        const targetElement: HTMLElement = document.querySelector(target);
                        targetElement?.focus();
                    }
                }
            });
        });
    },
};

export default SkipLinks;
